import apiFetch from '../apiFetch'

export default function (values, token, signal) {
  return apiFetch({endPoint: `Envasado/prepararMaquinaEnvasado`, method: 'POST', body: values, token: token, signal: signal})
}
